<template>
  <div class="main__content">
    <div class="table__header_bar control-panel">
      <div>
        <InputSearch isFilter @detectSearchValue="searchTableHandler" />
      </div>
      <Button isControl iconName="plus" @click.native="createResearchFile">
        {{ $t('sections.add_research_file') }}
      </Button>
    </div>
    <Table
      v-if="!!getResearchFilesTableAdmin"
      :content="getResearchFilesTableAdmin"
      @tableHandler="tableHandler"
    />
    <v-skeleton-loader v-else type="table" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Table from '@/elements/Table';
export default {
  components: {
    Table,
  },
  data() {
    return {};
  },

  created() {
    this.$store.dispatch('researchFilesTableContentAdmin');
  },

  computed: {
    ...mapGetters(['getResearchFilesTableAdmin']),
  },
  methods: {
    createResearchFile() {
      this.$router.push({
        name: 'content-administrator_research-files-create',
        params: { activity: 'create' },
      });
    },
    searchTableHandler(val) {
      this.$store.commit('SET_TABLE_SORT_DATA', { search: val });
      this.$store.dispatch('researchFilesTableContentAdmin');
    },
    tableHandler() {
      this.$store.dispatch('researchFilesTableContentAdmin');
    },
  },
};
</script>
